import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"

export const Selects = (props) => {
    return (
        <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-select-label">{props?.label}</InputLabel>
            <Select
                label={props?.label}
                id={props?.name}
                name={props?.name}
                value={props?.value}
                onChange={props?.onChange}
                style={props?.style}
                fullWidth
            >
                <MenuItem value='' key=''>Ninguno</MenuItem>
                {props.data?.map(item => (
                    <MenuItem key={item?.id} value={item?.id} style={{textTransform: 'uppercase'}}>{item?.nombre}</MenuItem>
                ))}
        </Select>
        </FormControl >
    )
}